import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import FreightRatesArticle from "./pages/articles/FreightRatesArticle";
import TrainConnectionArticle from "./pages/articles/TrainConnectionArticle";
import CarbonMarketArticle from "./pages/articles/CarbonMarketArticle";
import AWSOutageArticle from "./pages/articles/AWSOutageArticle";
import PortStrikesArticle from "./pages/articles/PortStrikesArticle";
import COSCOBoxshipArticle from "./pages/articles/COSCOBoxshipArticle";
import COSCOShippingArticle from "./pages/articles/COSCOShippingArticle";
import SFExpressUKArticle from "./pages/articles/SFExpressUKArticle";
import ChinaEURailFreightArticle from "./pages/articles/ChinaEURailFreightArticle";
import CMAGMSuezArticle from "./pages/articles/CMAGMSuezArticle";
import UPSKuehneArticle from "./pages/articles/UPSKuehneArticle";
import AmazonNetherlandsArticle from "./pages/articles/AmazonNetherlandsArticle";
import AlibabaLiegeArticle from "./pages/articles/AlibabaLiegeArticle";
import InPostIberiaArticle from "./pages/articles/InPostIberiaArticle";
import EuroCommerceTaxArticle from "./pages/articles/EuroCommerceTaxArticle";
import MonthlyLogisticsInsightsArticle from "./pages/articles/MonthlyLogisticsInsightsArticle";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/article/freight-rates" element={<FreightRatesArticle />} />
            <Route path="/article/train-connection" element={<TrainConnectionArticle />} />
            <Route path="/article/carbon-market" element={<CarbonMarketArticle />} />
            <Route path="/article/aws-outage" element={<AWSOutageArticle />} />
            <Route path="/article/port-strikes" element={<PortStrikesArticle />} />
            <Route path="/article/cosco-boxship" element={<COSCOBoxshipArticle />} />
            <Route path="/article/cosco-shipping" element={<COSCOShippingArticle />} />
            <Route path="/article/sf-express-uk" element={<SFExpressUKArticle />} />
            <Route path="/article/china-eu-rail" element={<ChinaEURailFreightArticle />} />
            <Route path="/article/cma-cgm-suez" element={<CMAGMSuezArticle />} />
            <Route path="/article/ups-kuehne" element={<UPSKuehneArticle />} />
            <Route path="/article/amazon-netherlands" element={<AmazonNetherlandsArticle />} />
            <Route path="/article/alibaba-liege" element={<AlibabaLiegeArticle />} />
            <Route path="/article/inpost-iberia" element={<InPostIberiaArticle />} />
            <Route path="/article/eurocommerce-tax" element={<EuroCommerceTaxArticle />} />
            <Route path="/article/monthly-logistics-insights" element={<MonthlyLogisticsInsightsArticle />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </HashRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;